import React, { PureComponent, Fragment } from 'react'
import { Route } from 'react-router-dom'
import ShopSettingsWithUpdate from '../../../components/layout/ShopSettingsWithUpdate'
import BillingInfo from '../../../components/Billing/BillingInfo'

class BillingPage extends PureComponent {
  render() {
    const { match } = this.props

    return (
      <Fragment>
        {/* <h2 style={{ textTransform: 'capitalize' }}>{shop.name}</h2> */}
        <Route exact path={`${match.url}/`} component={BillingInfo} />
      </Fragment>
    )
  }
}

export default ShopSettingsWithUpdate(BillingPage)



// WEBPACK FOOTER //
// ./src/containers/Settings/Billing/BillingPage.js